<template>
  <div class="o-create-user">
    <div class="container">
      <div class="row">
        <div class="col-md-8 offset-md-2">
          <div class="o-create-user__content">
            <h1 class="o-create-user__headline h2">
              {{ $t('createUser','Opret bruger') }}
            </h1>
            <template v-if="!isUserCreated">
              <div class="d-flex mb-6">
                <base-button
                  class="o-create-user__mode-button p-3 mx-2"
                  :class="[isExistingCustomerSelected ? '-primary' : '-outline-primary']"
                  @click="isExistingCustomerSelected = true"
                >
                  <h3>{{ $t('createUserExistingCustomer', 'Eksisterende kunde') }}</h3>
                  <p>Vælg denne mulighed hvis du allerede har et kundenummer</p>
                </base-button>
                <base-button
                  class="o-create-user__mode-button p-3 mx-2"
                  :class="[!isExistingCustomerSelected ? '-primary' : '-outline-primary']"
                  @click="isExistingCustomerSelected = false"
                >
                  <h3>{{ $t('createUserNewCustomer', 'Ny kunde') }}</h3>
                </base-button>
              </div>
              <div
                v-if="showCustomerNumberNotFoundError"
                class="p-5 mb-5 bg-danger text-white"
              >
                Vi kunne desværre ikke finde dit kundenummer i vores system.<br>
                Du har nu mulighed for at oprette dig som ny kunde nedenfor.
              </div>
              <create-user-new
                v-if="!isExistingCustomerSelected"
                v-model="formData"
                @success="successfullyCreatedUser"
              />
              <create-user-existing
                v-else
                v-model="formData"
                @customer-number-not-found="handleCustomerNumberNotFound"
                @success="successfullyCreatedUser"
              />
            </template>
            <div v-else>
              {{ userCreatedMessage }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BaseButton from '@/components/atoms/BaseButton';
import CreateUserNew from '@/components/molecules/CreateUserNew';
import CreateUserExisting from '@/components/molecules/CreateUserExisting';

export default {
  name: 'CreateUser',
  components: {
    BaseButton,
    CreateUserNew,
    CreateUserExisting
  },
  data () {
    return {
      formData: {
        billingInformation: {
          address: '',
          zipCode: '',
          city: '',
        },
        shippingInformation: {
          address: '',
          zipCode: '',
          city: '',
        },
        email: '',
        fullName: '',
        companyName: '',
        companyCvrNumber: '',
        password: '',
        passwordConfirm: '',
        differentShippingAddress: false,
        customerNumber: '',
        phoneNumber: '',
        invoiceEmail: '',
        accountStatementEmail: ''
      },
      isExistingCustomerSelected: true,
      isUserCreated: false,
      userCreatedMessage: '',
      showCustomerNumberNotFoundError: false,
    }
  },
  methods: {
    handleCustomerNumberNotFound () {
      // Scroll to top to ensure user sees the error message
      window.scrollTo(0, 0);
      this.isExistingCustomerSelected = false;
      this.showCustomerNumberNotFoundError = true;
      this.formData.password = '';
      this.formData.passwordConfirm = '';
    },
    successfullyCreatedUser (message) {
      this.isUserCreated = true;
      this.userCreatedMessage = message;
      // Form is larger than successfull message so scrolling to top to not stay at footer position
      window.scrollTo(0, 0);
    }
  }
}

</script>
